// @ts-ignore
import { useSelector } from 'react-redux';
import { getActiveDrawers } from '../selectors/drawers';

export const getDrawers = () => useSelector(getActiveDrawers);
